import { render, staticRenderFns } from "./ruleConfig.vue?vue&type=template&id=47d98669&scoped=true&"
import script from "./ruleConfig.vue?vue&type=script&lang=js&"
export * from "./ruleConfig.vue?vue&type=script&lang=js&"
import style0 from "./ruleConfig.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ruleConfig.vue?vue&type=style&index=1&id=47d98669&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d98669",
  null
  
)

export default component.exports